module.exports = __webpack_public_path__ + "static/media/remoteAuthTemp.3eb5e1ca.xlsx";